import { render, staticRenderFns } from "./Historicaldata.vue?vue&type=template&id=dff9ed98&scoped=true&"
import script from "./Historicaldata.vue?vue&type=script&lang=js&"
export * from "./Historicaldata.vue?vue&type=script&lang=js&"
import style0 from "./Historicaldata.vue?vue&type=style&index=0&id=dff9ed98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff9ed98",
  null
  
)

export default component.exports